if (window.location.pathname.startsWith('/products/'))  {
  const productStickyBar = document.querySelector('.product-sticky-bar')

  window.addEventListener('DOMContentLoaded', () => {
    if (productStickyBar) {
      const stickyATC = productStickyBar.querySelector('.buy-buttons')
      const variantElement = document.querySelector("[data-block-type='variant-picker']")

      if (stickyATC) {
        stickyATC.addEventListener('click', (e) => {
          e.preventDefault()
          const productForm = document.querySelector('product-form')
          if (productForm) {
            productForm.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }
        })
      }

      if (variantElement) {
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              productStickyBar.classList.remove('is-visible')
            } else {
              productStickyBar.classList.add('is-visible')
            }
          });
        });

        observer.observe(variantElement);
      }
    }
  })

  window.addEventListener('load', () => {
    productStickyBar.classList.add('is-visible')
  })
}
